module.exports = __webpack_public_path__ + "static/media/22791711_1629550220453496_3009440124036422740_o.b4c6148a.jpg";